module.exports = __webpack_public_path__ + "static/img/ent-detail-37.c33f54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-37.jpg
// module id = ksDy
// module chunks = 52